module.exports = __webpack_public_path__ + "img/basics-goods-bai.fd2b2429.svg";